import * as React from "react";
import { ColumnProps } from './CellColumnProps';

export interface Props extends ColumnProps
{
    render: (props: Props) => JSX.Element | null;
    getValue?: (item: any) => any;
}

// This column is the most generic one. It renders the template which was provided by the render prop
export const DataGridTemplateColumn = (props: Props) => props.render(props);



// WEBPACK FOOTER //
// ./src/components/DataGrid/DataGridTemplateColumn.tsx